module.exports = "<div class=articles ng-cloak> <md-card> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> </md-card> <md-card> <rkc-articles-table table-content=c.searchResult table-definition=c.tableDefinition></rkc-articles-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/articles/articles.html
 ** module id = 487
 ** module chunks = 0
 **/